import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ExternalBranchService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService,
        private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
        sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

        const params = {
            filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
        };

        return this.httpClient.post(this.baseApiUrl + 'externalbranch/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `externalbranch/${id}?isMaintenance=${forMaintenance}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getExternalBranchByIfscCode(ifscCode: string): Observable<any> {
        return this.httpClient.get(`${this.baseApiUrl}externalbranch/ifsccode/${ifscCode}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(externalBranch: any): Observable<any> {
        return this.httpClient.post(`${this.baseApiUrl}externalbranch`, externalBranch).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(externalBranch: any): Observable<any> {
        return this.httpClient.put(`${this.baseApiUrl}externalbranch`, externalBranch).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
